import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['pricing', 'packages'];

export function usePackages() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/pricing/packages');
      return data?.packages || data?.data || data || [];
    },
    staleTime: 30_000
  });
}

export function useCreatePackage() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/pricing/packages', body).then((r) => r.data),
    successMessage: 'تمت إضافة الباقة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useUpdatePackage() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/pricing/packages/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ الباقة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useDeletePackage() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/pricing/packages/${id}`).then((r) => r.data),
    successMessage: 'تم حذف الباقة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}
